export default class DtoSiteType {
    constructor(obj) {
        this.id = obj.id
        this.parameter = obj.parameter
        this.definition = obj.definition
    }
}
